import React from 'react';
import { Calendar, Row, Col, Button, Typography, message, Modal, Input } from "antd";
import './render-calender.style.scss';
import { getDate, getMonth, addMonth, subtractMonth, getDateMonthInReadable, getAPIDateFormat } from '../../../utils/dates-util';
import { useEffect } from 'react';
import { useState } from 'react';
import { formateDataForDayWise, getDayStatus } from './render-calender.module';
import { useDispatch } from 'react-redux';
import { insertDemandDaysAction } from '../../../actions/demand-days.action';
import { isValid, isValidArray } from '../../../utils/utilities';

const {Text} = Typography;

export const ScheduleListCalender = (props) => {

    const {
        selectedDate,
        demandDaysData,
        selectedOrigin,
        selectedDestination
    } = props;

    const dispatch = useDispatch();

    const isMobile = false;

    const [dayWiseData,setDayWiseData] = useState({});
    const [currentDate , setCurrentDate] = useState(selectedDate);
    const [nextDate , setNextDate] = useState(selectedDate);
    const [existingDemandDates, setExistingDemandDates] = useState([]);
    const [currentSelectedDate, setCurrentSelectedDate] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [description, setDescription] = useState('');
    const [selectedDateForModal, setSelectedDateForModal] = useState(null);
    
    useEffect(()=>{
        if(isValidArray(demandDaysData)&&isValid(demandDaysData.dates)){
            setDayWiseData(formateDataForDayWise(demandDaysData.dates));
            setExistingDemandDates(demandDaysData.dates);
        }
    },[demandDaysData]);

    useEffect(()=>{
        setCurrentDate(selectedDate);
    },[selectedDate]);

    useEffect(()=>{
        let secondDate = addMonth(currentDate,1);
        setNextDate(secondDate);
    },[currentDate]);

    const onPreviousClick =()=>{
        if(isMobile){
            setCurrentDate(subtractMonth(currentDate,1));
        }else{
            setCurrentDate(subtractMonth(currentDate,2));
        }
    }

    const onNextClick =()=>{
        if(isMobile){
            setCurrentDate(addMonth(currentDate,1));
        }else{
            setCurrentDate(addMonth(currentDate,2));
        }
    }

    const handleDateSelect = (date) => {
        let apidate = getAPIDateFormat(date);
        setSelectedDateForModal(apidate);
        setCurrentSelectedDate(apidate);
        setIsModalVisible(true);
        setDescription('');
    }

    const handleModalOk = () => {
        console.log({selectedOrigin});
        
        if (selectedOrigin.length == 1 && selectedDestination.length == 1) {
            if (selectedDateForModal) {
                dispatch(insertDemandDaysAction({
                    originList: selectedOrigin, 
                    destinationList: selectedDestination, 
                    selectedDate: selectedDateForModal,
                    description: description
                }));
                setCurrentSelectedDate(null);
                setIsModalVisible(false);
                setDescription('');
                setSelectedDateForModal(null);
            }
        } else {
            message.warn("Add Demand days can be added with only single origin and destination city");
        }
    }

    const handleModalCancel = () => {
        setIsModalVisible(false);
        setCurrentSelectedDate(null);
        setDescription('');
        setSelectedDateForModal(null);
    }

    return(
        <div>
            <Row gutter={[16,16]} justify="center" align="middle">
                        <Col>
                            <div className="site-extended-calendar">
                                <Calendar 
                                    value={currentDate}
                                    fullscreen={false}
                                    headerRender={()=>{
                                        return (
                                        <Row gutter={[16,16]} align="middle">
                                            <Col>
                                                <Button type="link" className="previous-calender-btn" onClick={onPreviousClick}>
                                                    <Text className="normal-txt">Previous</Text>
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Text strong>{getDateMonthInReadable(currentDate)}</Text>
                                            </Col>  
                                            {isMobile&&
                                                <Col>
                                                    <Button type="link" className="previous-calender-btn" onClick={onNextClick}>
                                                        <Text className="normal-txt">Next</Text>
                                                    </Button>
                                                </Col>
                                            }      
                                        </Row>
                                        )              
                                    }}
                                    dateFullCellRender={(date)=>{
                                        let day = getDate(date);
                                        let month = getMonth(date);
                                        let currentMonth = getMonth(currentDate);
                                        if(month===currentMonth){
                                            let apidate = getAPIDateFormat(date);
                                            let className = getDayStatus(apidate,dayWiseData);
                                            let selectedClassName = currentSelectedDate === apidate ? "schedule-date-selected" : "";
                                            return (
                                                <div className={`current-date ${className}`}>
                                                    <div className={`${selectedClassName}`}>{day}</div>
                                                </div>
                                            )
                                        }else{
                                            return (
                                                <div className={`next-month-date`}>
                                                    <div>{day}</div>
                                                </div>
                                            )
                                        }
                                    }}
                                    mode="month"
                                    onSelect={handleDateSelect}
                                />
                            </div>
                        </Col>
                        {!isMobile&&
                           <Col>
                                <div className="site-extended-calendar">
                                    <Calendar 
                                                value={nextDate}
                                                fullscreen={false}
                                                headerRender={()=>{
                                                    return (
                                                    <Row gutter={[16,16]} align="middle" justify="end">
                                                        <Col>
                                                            <Text strong>{getDateMonthInReadable(nextDate)}</Text>
                                                        </Col>
                                                        <Col>
                                                            <Button type="link" className="previous-calender-btn" onClick={onNextClick}>
                                                                <Text className="normal-txt">Next</Text>
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                    )              
                                                }}
                                                dateFullCellRender={(date)=>{
                                                    let day = getDate(date);
                                                    let month = getMonth(date);
                                                    let nextMonth = getMonth(nextDate);
                                                    if(month===nextMonth){
                                                        let apidate = getAPIDateFormat(date);
                                                        let className = getDayStatus(apidate,dayWiseData);
                                                        let selectedClassName = currentSelectedDate === apidate ? "schedule-date-selected" : "";
                                                        return (
                                                            <div className={`current-date ${className}`}>
                                                                <div className={`${selectedClassName}`}>{day}</div>
                                                            </div>
                                                        )
                                                    }else{
                                                        return (
                                                            <div className={`next-month-date`}>
                                                                <div>{day}</div>
                                                            </div>
                                                        )
                                                    }
                                                }}
                                                mode="month"
                                                onSelect={handleDateSelect}
                                            />
                                </div>
                            </Col>
                        }
                    </Row>

                    <Modal
                        title="Add Demand Day"
                        visible={isModalVisible}
                        onOk={handleModalOk}
                        onCancel={handleModalCancel}
                        okText="OK"
                        cancelText="Cancel"
                    >
                        <div style={{ marginBottom: 16 }}>
                            <Text strong>Selected Date: </Text>
                            <Text>{selectedDateForModal}</Text>
                        </div>
                        <div>
                            <Text strong>Description:</Text>
                            <Input
                                placeholder="Enter description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                style={{ marginTop: 8 }}
                            />
                        </div>
                    </Modal>
        </div>
    );
};

ScheduleListCalender.defaultProps = {

};

ScheduleListCalender.propTypes = {

};
